const userAuth = JSON.parse(sessionStorage.getItem("authUser"));
const accessToken = "Bearer " + userAuth?.token;
export default accessToken